//#region [IMPORT]

// === CONSTANTS ===
import { FAILURE_CODE, SUCCESS_CODE } from "constants/general";

//#endregion

//-----------------------------------------------------------------
function validate(content, validation_info, field_type) {
  //-----------------------------------------------------------------
  const result = {
    content,
    status: SUCCESS_CODE,
  }

  const has_validation = !!validation_info;
  const has_content    = content !== '';
  const is_subclass    = field_type === 'subclass'
  const is_version     = field_type === 'version'

  if (!has_validation) {
    return result;
  }

  if (!is_subclass && !is_version && !has_content) {
    return result;
  }

  const { acceptableValues } = validation_info;
  const content_comp = content.toUpperCase();
  if ( acceptableValues?.length > 0 && !acceptableValues.some(x => x.toUpperCase() === content_comp)) {
    result.message = 'Please select a valid value.';
    result.status = FAILURE_CODE;
  }

  return result;
};


export { validate };